export default __webpack_public_path__ + "assets/images/5dc06d2f7e6df7f6231fbb24b7b635b7.png";